/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-15 08:18:35 */

const Keys = {
  adult: 'adult',
  child: 'child',
  destinationsLabel: 'destinationsLabel',
  destinationsPlaceholder: 'destinationsPlaceholder',
  search: 'search',
  dates: 'dates',
  noResultsFound: 'noResultsFound',
  searchError: 'searchError'
}; export default Keys;